import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { AgGridTableWrapper, AgGridWidgetWrapper, Loader } from '@mummssoftware/common-ui';
import { useTheme } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import { ReportContext } from '../Context/ReportContext';
import { ReportParamHeader } from '../Header/ReportParamHeader';
import { addExportHeader } from './utils';

var _ref = /*#__PURE__*/React.createElement(Loader, null);

export const ReportBody = ({
  reportHeader,
  gridAPIRef
}) => {
  const {
    props: {
      grid: gridTheme
    }
  } = useTheme();
  const {
    reportData,
    showLoader
  } = useContext(ReportContext);
  const commonColumnDefs = {
    wrapText: true,
    sortable: true,
    filterable: true,
    autoHeight: true,
    resizable: true
  };

  const getColumnDefs = () => reportHeader !== null && reportHeader !== void 0 && reportHeader.columnDefs ? addExportHeader(reportHeader) : [];

  const gridOptions = {
    detailRowAutoHeight: true,
    embedFullWidthRows: true,
    groupHeaderHeight: 20,
    defaultColDef: _objectSpread({}, commonColumnDefs),
    onGridReady: params => {
      params.columnApi.autoSizeAllColumns();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLoader && _ref, /*#__PURE__*/React.createElement(ReportParamHeader, {
    reportHeader: reportHeader
  }), /*#__PURE__*/React.createElement(AgGridWidgetWrapper, {
    id: "report-grid-wrapper",
    smallWidget: false,
    heightOffset: 225
  }, /*#__PURE__*/React.createElement(AgGridTableWrapper, {
    id: "report-table-wrapper",
    className: `${gridTheme.className} light max-width`,
    printMode: false
  }, /*#__PURE__*/React.createElement(AgGridReact, {
    onGridReady: params => {
      gridAPIRef.current = params.api;
    },
    gridOptions: gridOptions,
    rowData: reportData || [],
    rowHeight: gridTheme.rowHeight,
    headerHeight: gridTheme.headerHeight,
    suppressRowClickSelection: true,
    suppressCellSelection: true,
    columnDefs: getColumnDefs(),
    suppressPropertyNamesCheck: true
  }))));
};